import React from "react";

function getLabelFor(key) {
	return key.split("")
		.map((each, idx) => idx === 0 ? each.toUpperCase() : each)
		.map((each, idx) => idx !== 0 && each === each.toUpperCase() && key[idx - 1] !== key[idx - 1].toUpperCase() ? " " + each : each)
		.join("");
}
function getOptionsFromState(options, state) {
	var newOptions = {};
	Object.keys(state)
		.forEach(key => {
			var value = state[key];
			if (typeof options[key] === "number") value = Number(value);
			newOptions[key] = value;
		});
	return newOptions;
}

function getSelect(props, options) {
	return <select {...props}>
		{options.map(each => <option key={each} value={each}>{each}</option>)}
	</select>;
}

function getSourceValues(settingsType, indicatorType, chartType) {
	console.log(settingsType, indicatorType, chartType);
	var type = settingsType === "Chart" ? chartType : indicatorType;
	switch (type) {
		case "POINT_FIGURE":
		case "RENKO": {
			return [ "close", "hi/lo" ];
		}
		default:
			return [ "open", "high", "low", "close" ];
	}
}

class SettingsModal extends React.Component {
	constructor(props) {
		super(props);
		this.initState = this.initState.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.valueLink = this.valueLink.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getInput = this.getInput.bind(this);
	}
	handleSubmit(e) {
		e.preventDefault();
		var { onSubmit, options, settingsType, onChartSettingsChange } = this.props;
		var newOptions = getOptionsFromState(options, this.state);
		if (settingsType === "Chart") {
			onChartSettingsChange(newOptions);
		} else {
			var { indicatorType: type, chartId, dataSeriesId  } = options;
			var indicatorToAdd = { type, chartId, dataSeriesId, options: newOptions};
			// console.log(indicatorToAdd);
			onSubmit(indicatorToAdd);
		}
	}
	componentDidMount() {
		if (this.refs.input_0) {
			this.refs.input_0.focus();
			if (this.refs.input_0.select) this.refs.input_0.select();
		}
	}
	componentWillMount() {
		this.initState(this.props);
	}
	componentWillReceiveProps(nextProps) {
		this.initState(nextProps);
	}
	initState(props) {
		var { options } = props;
		if (!options) return;

		var keys = Object.keys(options)
			.filter(key => key !== "indicatorType")
			.filter(key => key !== "chartId")
			.filter(key => key !== "dataSeriesId")
			.filter(key => typeof options[key] !== "object")
			.filter(key => typeof options[key] !== "function");

		var optionsInState = {};
		keys.forEach(key => optionsInState[key] = options[key]);

		this.setState(optionsInState);
	}
	handleChange(key, origValue, value) {
		var newState = {};
		newState[key] = value;
		this.setState(newState);
	}
	valueLink(key, origValue) {
		return {
			value: this.state[key],
			requestChange: this.handleChange.bind(null, key, origValue)
		};
	};
	getInput(key, idx) {
		var { options, settingsType, chartType } = this.props;

		var props = { className: "form-control",
			ref: `input_${ idx }`,
			name: key,
			valueLink: this.valueLink(key, options[key])
		};

		console.log(key, options[key]);
		switch (key) {
			case "reversalType":
				return getSelect(props, ["ATR", "FIXED"]);
			case "source":
				var options = getSourceValues(settingsType, options.indicatorType, chartType.value);
				return getSelect(props, options);
			default:
				return <input {...props}/>;
		}
	}
	render() {
		var { title, options, onSubmit, onClose, onDestroy, settingsType, chartType } = this.props;
		var submitLabel = "Change";
		var destroyLabel = "Remove this";

		var showDestroy = true;
		var settingsTitle;
		if (settingsType === "Chart" && ["RENKO", "KAGI", "POINT_FIGURE"].indexOf(chartType.value) > -1) {
			showDestroy = false;
			settingsTitle = chartType.label;
		} else if (settingsType === "Chart") {
			return null;
		} else {
			settingsTitle = `${ title } for ${ options.indicatorType }`;
		}

		// console.log(settingsType, chartType);
		return (
			<div>
				<div className="modal-backdrop fade in" />
				<div tabIndex="-1" style={ { "display": "block"} } className="modal fade in">
					<div className="modal-dialog  modal-md">
						<div className="modal-content">
							<form className="form-horizontal" onSubmit={this.handleSubmit}>
								<div className="modal-header">
									<button type="button" className="close" aria-hidden="true" onClick={onClose}>×</button>
									<h4 className="modal-title">{settingsTitle}</h4>
								</div> 
								<div className="modal-body">
									{Object.keys(this.state).map((key, idx) => 
										<div key={key} className="form-group">
											<label className="control-label col-sm-5" htmlFor="inputSuccess3">{getLabelFor(key)}</label>
											<div className="col-sm-4">
												{this.getInput(key, idx)}
											</div>
										</div>
									)}
								</div>
								<div className="modal-footer">
									{showDestroy
										? <button type="button" className="btn btn-danger" onClick={onDestroy}>{destroyLabel}</button>
										: null}
									<button type="submit" className="btn btn-success">{submitLabel}</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SettingsModal;


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/SettingsModal.jsx
 **/